<template>
  <project-one-toolbar-tab-layout
    id="project-one-toolbar-price-lead-time"
    qaid="project-one-toolbar-price-lead-time"
    :title="bp('summary')"
    :list="list"
  />
</template>

<script>
import ProjectOneToolbarTabLayout from '@/projectOne/components/toolbar/components/ProjectOneToolbarTabLayout.vue';
import {mapState} from 'vuex';

export default {
  name: 'ProjectOneToolbarPriceLeadTime',
  components: {
    ProjectOneToolbarTabLayout,
  },
  computed: {
    ...mapState('backend', ['b2b', 'consumerFriendlyMode']),
    ...mapState('projectOne', ['bikeData', 'bikeEta', 'bikeEtaVisible']),

    list() {
      const list = [
        {
          qaid: 'project-one-toolbar-price-lead-time-price',
          title: this.bp('basePrice'),
          description:
            this.b2b && !this.consumerFriendlyMode ? this.bikeData.defaultDealerCost : this.bikeData.defaultAdvertised,
        },
        {
          qaid: 'project-one-toolbar-price-lead-time-estimated-price',
          title: this.bp('estPrice'),
          description:
            this.b2b && !this.consumerFriendlyMode
              ? this.bikeData.calculatedDealerCost
              : this.bikeData.calculatedAdvertised,
        },
        {
          qaid: 'project-one-toolbar-price-lead-time-estimated-lead-time',
          title: this.bp('estLeadTime'),
          description: this.bikeEtaVisible ? `${this.bikeEta} ${this.bp('leadTimeDays')}` : null,
        },
      ];
      return list.filter((item) => Boolean(item.title) && Boolean(item.description));
    },
  },
};
</script>
